import { CalculatorContext } from "App";
import { useContext, useEffect } from "react";

interface NavbarProps {
  showCalculatedItems: () => void;
  showChooseProfile: () => void;
  showDownload: () => void;
  calculatedItemsCount: number;
}

export const Navbar = ({
  showCalculatedItems,
  showChooseProfile,
  showDownload,
  calculatedItemsCount,
}: NavbarProps) => {
  const handleDownload = () => {
    showDownload();
    window.scrollTo({ top: 0 });
  };

  const handleChooseProfile = () => {
    showChooseProfile();
    window.scrollTo({ top: 0 });
  };

  const handleCalculatedItems = () => {
    showCalculatedItems();
    window.scrollTo({ top: 0 });
  };

  const context = useContext(CalculatorContext);

  const { itemCount, translations } = context!;
  return (
    <nav>
      <span onClick={handleChooseProfile}>
        {translations["select-a-profile"]}
      </span>
      <span onClick={handleCalculatedItems}>
        {translations["counted-items"]} ({itemCount})
      </span>
      <span onClick={handleDownload}>{translations["download-items"]}</span>
    </nav>
  );
};
